import React, { FC } from 'react'
import Geosuggest from 'react-geosuggest'
import { useSelector } from 'react-redux'
import { IProps } from './types'

import './styles.scss'
import { Plann3rStore } from '../../../store/types'

const Location: FC<IProps> = ({ default_location = '',
  onChange,
  className = '' }) => {
  const meeting_address = useSelector(
    (state: Plann3rStore) => state.languages.strings.meeting_address,
  )

  return (
    <input
      id="location"
      className="grey full-width"
      type="text"
      value={default_location}
      data-lpignore="true"
      onChange={(e) => onChange(e.target.value)}
    />
  )

  // TODO: fix geosuggest component
  return (
    <Geosuggest
      className={className}
      initialValue={default_location}
      onChange={(location) => onChange(location.label)}
      onSuggestSelect={(location) => onChange(location.label)}
      onBlur={(location) => onChange(location.label)}
      placeholder={meeting_address}
    />
  )
}

export default Location
